import { render } from "./AccessoryManagement.vue?vue&type=template&id=fe63e448&scoped=true"
import script from "./AccessoryManagement.vue?vue&type=script&lang=js"
export * from "./AccessoryManagement.vue?vue&type=script&lang=js"

import "./AccessoryManagement.vue?vue&type=style&index=0&id=fe63e448&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe63e448"]])

export default __exports__